var CryptoJS = require("crypto-js");

const subdomain = window.location.hostname.split(".")[0];
const Encode_Decode_JSON = {
  stringify: function (DecodingVal) {
    var Data_Val = {
      Encode: DecodingVal.ciphertext.toString(CryptoJS.enc.Base64),
    };
    if (DecodingVal.iv) Data_Val.Decentral = DecodingVal.iv.toString();
    if (DecodingVal.salt) Data_Val.EndCode = DecodingVal.salt.toString();
    return JSON.stringify(Data_Val);
  },
  parse: function (StrVal) {
    var Data_Val = JSON.parse(StrVal);
    var DecodingVal = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(Data_Val.Encode),
    });
    if (Data_Val.Decentral)
      DecodingVal.Decentral = CryptoJS.enc.Hex.parse(Data_Val.Decentral);
    if (Data_Val.EndCode)
      DecodingVal.salt = CryptoJS.enc.Hex.parse(Data_Val.EndCode);

    return DecodingVal;
  },
};

const API_KEYS = Object.keys(process.env)
  .filter((key) => {
    return /^REACT_APP_V\d+_API_KEY$/.test(key);
  })
  .map((key) => {
    return process.env[key];
  });

const GetKey = (key) => {
  const matchedKey = API_KEYS.find((item) => item.length === key.length);
  return matchedKey;
};

export const Encrypt_Value = (Val, key) => {
  let apiKey = GetKey(key);
  if (!apiKey) {
    if (
      subdomain === "test" ||
      subdomain === "production" ||
      subdomain === "saravana" ||
      subdomain === "localhost"
    ) {
      alert(
        `API key not found for the provided key length. Encryption failed. ${key}`,
      );
      apiKey = key;
    } else {
      apiKey = key;
      console.error(
        `API key not found for the provided key length. Encryption failed. ${key}`,
      );
    }
    // return null;
  }
  return CryptoJS.AES.encrypt(JSON.stringify(Val), apiKey, {
    format: Encode_Decode_JSON,
  }).toString();
};

export const Decrypt_Value = (data, key) => {
  let apiKey = GetKey(key);
  if (!apiKey) {
    if (
      subdomain === "test" ||
      subdomain === "production" ||
      subdomain === "saravana" ||
      subdomain === "localhost"
    ) {
       alert(
        `API key not found for the provided key length. Decryption failed. ${key}`,
      );
      apiKey = key;
    } else {
      apiKey = key;
      console.error(
        `API key not found for the provided key length. Decryption failed. ${key}`,
      );
    }
    // return null;
  }
  return JSON.parse(
    CryptoJS.AES.decrypt(data, apiKey, {
      format: Encode_Decode_JSON,
    }).toString(CryptoJS.enc.Utf8),
  );
};
